import {
  MockMap,
} from '@ama-sdk/core';
import {
  ErrorMessage,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  BoardingPassDataRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
  MockAcceptance,
  MockBoardingPassResult,
  MockJourney,
} from '@dapi/sdk/spec';
import {
  assignSeatToJourneyElements,
  retrieveSeatMapsJourneyDriven,
} from '../common/seatmap';
import {
  acceptedChosenJourney,
  journeyElementIds,
  journeys,
  validRegulatoryJourney,
  validRegulatoryJourneyFirstPax,
} from './journey-logic';
import {
  addRegulatoryDetailsFirstPax,
  addRegulatoryDetailsSecondPax,
  getRegulatoryDetailsFirstPax,
  getRegulatoryDetailsFirstPaxCompleted,
  getRegulatoryDetailsSecondPax,
  getRegulatoryDetailsSecondPaxCompleted,
} from './regulatory-logic';

const bp: MockBoardingPassResult[] = combineBoardingPassResults([{
  boardingPassData: BoardingPassDataRepository.TSA
}], {
  journeyElementIds
}).items;
const mockAcceptanceEligibleForVDB: MockAcceptance = {
  ...AcceptanceRepository.ACCEPTED,
  isEligibleForVoluntaryDeniedBoarding: true,
  isVoluntaryDeniedBoarding: false
};
const mockAcceptanceOptedForVDB: MockAcceptance = {
  ...AcceptanceRepository.ACCEPTED,
  isEligibleForVoluntaryDeniedBoarding: false,
  isVoluntaryDeniedBoarding: true
};

const retrieveJourney: MockJourney[] = [
  validRegulatoryJourneyFirstPax,
  validRegulatoryJourney,
  {
    ...acceptedChosenJourney,
    acceptance: mockAcceptanceEligibleForVDB
  },
  {
    ...acceptedChosenJourney,
    acceptance: mockAcceptanceOptedForVDB
  }
];

const noUnpaid: ErrorMessage[] = [{
  code: '10000',
  title: 'No unpaid service',
  type: 'error',
  id: '10000'
}];

const seatmap = retrieveSeatMapsJourneyDriven(journeys[0], journeys[0].travelers.map((t) => t.id).filter((id): id is string => !!id));

export const checkinPNROW1Journey2ADTUSRegMissing: MockMap = {
  addRegulatoryDetails: [
    ...[...addRegulatoryDetailsFirstPax].map((reg) => createMockData({
      ...reg,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    })),
    ...[...addRegulatoryDetailsSecondPax].map((reg) => createMockData({
      ...reg,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    }))
  ],
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(bp, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, noUnpaid), createMockDataWithResponse(undefined, 404, noUnpaid)],
  getRegulatoryDetails: [
    createMockData({
      ...getRegulatoryDetailsFirstPax,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsSecondPax,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsFirstPaxCompleted,
      travelerId: 'JOURNEY-TRAVELER-0-MOCK'
    }),
    createMockData({
      ...getRegulatoryDetailsSecondPaxCompleted,
      travelerId: 'JOURNEY-TRAVELER-1-MOCK'
    })
  ],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(mockAcceptanceEligibleForVDB, 201)],
  retrieveJourney: retrieveJourney.map((j) => createMockData(j)),
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeys, 201)],
  updateVoluntaryDeniedBoardingOnJourney: [createMockData(mockAcceptanceOptedForVDB)],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
